exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".create-gateway .modal-dialog .modal-content .modal-header {\n  padding-bottom: 12px; }\n\n.create-gateway .free-ips {\n  padding: 10px 5px; }\n\n.create-gateway textarea {\n  margin: 0;\n  padding: 6px; }\n\n.create-gateway input[type=number] {\n  width: 180px; }\n\n.create-gateway .description {\n  margin-bottom: 50px; }\n\n.create-gateway .select, .create-gateway input[type=text] {\n  width: 240px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/network/gateways/create-gateway.scss
// module id = M+ED
// module chunks = 0